import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "../../../../common/Button";
import InputBox from "../../../../common/interactive/InputBox";
import InputBoxCurrency from "../../../../common/interactive/InputBoxCurrency";
import PannelBody from "../../../../fragments/PannelBody";
import PannelFooter from "../../../../fragments/PannelFooter";
import { createOutsideLien } from "../../../../../lib/fetchApi";
import { notificationActions } from "../../../../../store/notifications";
import { caseActions } from "../../../../../store/case";

export default function OutsideLienForm({closeModal}) {
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false) 
    const [amount, setAmount] = useState()

    const activeCase = useSelector(state => state.case.activeCase) 
    const userToken = useSelector(state => state.user.token)

    async function createNewOutsideLienHandler(event) {
        event.preventDefault()
        setIsLoading(true)

        try {
            const fd = new FormData(event.target)

            const formData = Object.fromEntries(fd.entries())       

            const body = {
                type: formData.type,
                vendor: formData.vendor,
                amount: Number(amount),         
            }

            let create = await createOutsideLien(userToken, activeCase.case.id, body)

            if (create?.errorMessage) {
                dispatch(notificationActions.setError(create))
            } else {       
                if (closeModal) {
                    closeModal()
                }

                let dispatchBody = {
                    folder: 'case_outside_liens',
                    itemId: create?.id,
                    item: create
                }   
                dispatch(caseActions.pushWholeItemInArray(dispatchBody))     
            } 
        } finally {
            setIsLoading(false)
        }
    }


    function setAmountHandler(data) {
        setAmount(data.data.value)
    }

    return <form  onSubmit={createNewOutsideLienHandler}>
        <PannelBody>
            <div className={`row`}>
                <InputBox name={'type'} label={'Type'} required={true}/>
            </div>
            
            <div className={`row`}>
                <InputBox name={'vendor'} label={'Vendor'} required={true}/>
            </div>

            <div className={`row`}>
                <InputBoxCurrency action={setAmountHandler} name={'amount'} label={'Amount'} identifier={{type: null, field: 'amount', type_id: null, folder: null}} fullBox={true} required={true}/>
            </div>    
            
        </PannelBody>
        <PannelFooter>
            <Button type='submit' isLoading={isLoading} width={'full'}>
                Submit 
                <i className="ti ti-chevron-right"></i>
            </Button>
        </PannelFooter>
    </form>
}